module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Sliders\n      "), _c('small', [_vm._v("range sliders")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Sliders")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ion Slider")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row margin"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    attrs: {
      "id": "range_1",
      "type": "text",
      "name": "range_1",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    attrs: {
      "id": "range_2",
      "type": "text",
      "name": "range_2",
      "value": "1000;100000",
      "data-type": "double",
      "data-step": "500",
      "data-postfix": " &euro;",
      "data-from": "30000",
      "data-to": "90000",
      "data-hasgrid": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row margin"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    attrs: {
      "id": "range_5",
      "type": "text",
      "name": "range_5",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    attrs: {
      "id": "range_6",
      "type": "text",
      "name": "range_6",
      "value": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row margin"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    attrs: {
      "id": "range_4",
      "type": "text",
      "name": "range_4",
      "value": "10000;100000"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Bootstrap Slider")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row margin"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "horizontal",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "red"
    }
  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"red\"")]), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "horizontal",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "blue"
    }
  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"blue\"")]), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "horizontal",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "green"
    }
  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"green\"")]), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "horizontal",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "yellow"
    }
  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"yellow\"")]), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "horizontal",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "aqua"
    }
  }), _vm._v(" "), _c('p', [_vm._v("data-slider-id=\"aqua\"")]), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "horizontal",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "purple"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("data-slider-id=\"purple\"")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "vertical",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "red"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "vertical",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "blue"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "vertical",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "green"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "vertical",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "yellow"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "vertical",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "aqua"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "slider form-control",
    attrs: {
      "type": "text",
      "value": "",
      "data-slider-min": "-200",
      "data-slider-max": "200",
      "data-slider-step": "5",
      "data-slider-value": "[-100,100]",
      "data-slider-orientation": "vertical",
      "data-slider-selection": "before",
      "data-slider-tooltip": "show",
      "data-slider-id": "purple"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de79dcc2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ui/Sliders.vue
// module id = 2096
// module chunks = 1